import React from 'react';
import classes from './Overlay.scss';

const overlay = (props) => {
    return (
        <div {...props} className={`${classes.Overlay} u-phoneHide`}></div>
    );
}

export default overlay;


// WEBPACK FOOTER //
// ./src/components/UI/Overlay/Overlay.js